import React from "react";

import { Button, Stack, Typography } from '@material-ui/core';
import { ListChildComponentProps, areEqual } from 'react-window';

import IconArrowForward from '@material-ui/icons/ArrowForward';

import { StringParam, useQueryParams } from "use-query-params";

import { MessageData, MessageGiphyData, MessagePhotoData, MessageTranslatedData, MessageVoiceData, MesssageStickerData } from "../../types";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";
import { Link } from "@reach/router";
import LoadMoreButton from "../../components/LoadMoreButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { actions } from '../../services/chats';




const Row: React.FC<ListChildComponentProps> = ({ data, index, style }) => {

  const [ filters ] = useQueryParams({
    type: StringParam
  });
  const state = useSelector((state: RootState) => state.chats);
  const dispatch = useDispatch();

  const loadMore = () => {
    dispatch(actions.loadMoreMessages(filters.type || 'all'));
  }


  if (index === data.length) {
    return (
      <LoadMoreButton style={style} onClick={loadMore} loading={state.loadingMore} disabled={!state.cursor} />

    );
  }

  const message = data[ index ] as MessageData;

  const renderMessage = () => {
    if (message.type === 'photo') {
      const data = message.data as MessagePhotoData;
      return (
        <a href={`${process.env.REACT_APP_CDN_URL}/${data.path}`} target="_blank" rel="noreferrer">
          <img src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} height={120} />
        </a>
      )
    }

    if (message.type === 'sticker') {
      const data = message.data as MesssageStickerData;
      return <img src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} width={50} />
    }

    if (message.type === 'giphy') {
      const data = message.data as MessageGiphyData;
      const ratio = data.width / data.height;
      const height = 120;
      const width = height * ratio;
      return <img src={data.url} alt={message.id} width={width} height={height} />
    }

    if (message.type === 'voice') {
      const data = message.data as MessageVoiceData;
      return (
        <audio controls>
          <source src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} type="audio/mp4" />
        </audio>
      );
    }

    if (message.type === 'translated') {
      const data = message.data as MessageTranslatedData;
      return <Typography>{data.en}</Typography>
    }


    return <Typography>{message.data}</Typography>;
  }


  const toUserId = message.fromUserId === message.users[ 0 ] ? message.users[ 1 ] : message.users[ 0 ];

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={4}
      style={style}
      sx={{borderBottom: 1, borderColor: 'divider', minWidth: 800,}}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <ProfileAvatar userId={message.fromUserId} />
        <IconArrowForward color="disabled" />
        <ProfileAvatar userId={toUserId} />
      </Stack>
      <Stack sx={{ flex: 1 }} direction="column">
        {renderMessage()}
        <Typography variant="caption">{timeAgo(message.createTime.toDate())}</Typography>
      </Stack>
      <Button component={Link} to={`/chats/${message.chatId}`}>View Chat</Button>
    </Stack>
  );
};

const ChatMessage = React.memo(Row, areEqual);

export default ChatMessage;